
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/quick-setup",
      function () {
        return require("private-next-pages/resources/quick-setup.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/quick-setup"])
      });
    }
  